import AOS from 'aos';

AOS.init({
    anchorPlacement: 'top-bottom',
    delay: 50,
    offset: 100,    
    duration: 600,

    once: true,
});